<template>
  <div id="statement-asset" v-if="asset && asset.content_type">
    <div class="col-md-12">
      <a :href="asset.url" v-if="isImage">
        <img class="asset" :src="`${asset.url}`">
      </a>
      <a class="asset-url" target="_blank" :href="asset.url" v-if="isAudio">
        <div class="asset audio">
          <i class="fa fa-music"></i>
          &nbsp;
          <span>{{asset.file_name}}</span>
        </div>
      </a>
      <a v-if="editable" class="pull-right action-button">
        <i class="ti-close" @click="removeAssetClicked(asset.id)"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatementAsset',
  components: {},
  props: {
    asset: {
      type: Object,
      required: false,
    },
    statementId: {
      type: Number,
      required: true,
    },
    inspectionStatementId: {
      type: Number,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editable: true,
    };
  },
  created() {
    this.editable = this.$route.name !== 'InspectionReportScreen' && !this.readOnly;
  },
  computed: {
    isAudio() {
      return this.asset.content_type.includes('audio');
    },
    isImage() {
      return this.asset.content_type.includes('image');
    },
  },
  methods: {
    removeAssetClicked(id) {
      this.$emit('removeAssetClicked', {
        id,
        statementId: this.statementId,
        inspectionStatementId: this.inspectionStatementId,
      });
    },
  },
  watch: {},
};
</script>

<style lang="scss">
#statement-asset {
  .action-button {
    cursor: pointer;
    position: absolute;
    top: 2%;
    right: 7%;
    color: var(--main-color);
  }
  .asset {
    width: 100%;
  }

  @media print {
    .action-button {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inspections/StatementAsset.vue